<template>
    <div class="confirm">
        <Modal v-model="deleteConfirm" class-name="vertical-center-modal give-up-mdl" width="360">
            <div style="padding-top:64px;padding-bottom:68px;">
                <p class="red-font" style="font-size:20px;">确定要操作吗？</p>
                <div class="oper-btn" style="margin-top:40px;">
                    <button @click="cancel" class="cancel-btn" style="width:86px">
                        否
                    </button>
                    <button @click="ok" class="main-btn" style="width:86px">
                        是
                    </button>
                </div>
            </div>
            <div class="close-btn" slot="close">
                <i class="iconfont icon-pop-close"></i>
            </div>
        </Modal>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                deleteConfirm:false,
                params:{}
            }
        },
        methods:{
            open(params){
                this.params = params;
                this.deleteConfirm = true;
            },
            ok(){
                this.deleteConfirm = false;
                this.$emit('confirm',this.params);
            },
            cancel(){
                this.deleteConfirm = false;
            }
        }
    }
</script>
<style>

</style>